export default "__VITE_ASSET__O81TxTkM__"